<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M9.45333 16.7867L11.3333 18.6667L18 12L11.3333 5.33333L9.45333 7.21333L12.8933 10.6667H0V13.3333H12.8933L9.45333
           16.7867ZM21.3333 0H2.66667C1.18667 0 0 1.2 0 2.66667V8H2.66667V2.66667H21.3333V21.3333H2.66667V16H0V21.3333C0 22.8
           1.18667 24 2.66667 24H21.3333C22.8 24 24 22.8 24 21.3333V2.66667C24 1.2 22.8 0 21.3333 0Z"
    fill="white"
    opacity="0.75"
  />
</svg>
